import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
export default function FooterContainer({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  if (!children) return null;
  return (
    <div
      className={twMerge(
        'border-t border-neutral-200 px-2 py-1 bg-neutral-50 rounded-b',
        className,
      )}
    >
      {children}
    </div>
  );
}
